import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { ModalButtonArea, BigButton } from '.';
import { apiErrorHandler } from '../helpers/axiosHelper';
import pluralize from 'pluralize';
import { CURRENT_USER } from '../constants/projectConstants';
import { getLocalStorage } from '../helpers/jsHelper';
import { RestoreIcon } from '../components/icons/RestoreIcon'

export default function RendersRestorePopup(props) {
  const user = getLocalStorage(CURRENT_USER, true);
  // console.log('userDetails', user);

  const { selectedList, id, isPlural, actionWord = 'delete', user_details } = props;
  const selectedListCount = selectedList?.length;
  const [modalOpen, setModalOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const phrase = selectedListCount > 1 ? 'these renders' : 'this render';
  const deleteTitle = `Are you sure you want to ${actionWord} ${phrase}?`;
  const deleteDescription = ``;
  const deleteButtonPrompt = _.capitalize(actionWord);
  let errorMessage = `There was an error trying to restore ${phrase}`;
  let successMessage = `${_.capitalize(phrase)} have been successfully ${actionWord}d`;

  let buttonIcon = RestoreIcon;

  useEffect(() => {
    return () => {
      setProcessing(false);
    };
  }, []);
  function processAction() {

    if (_.isFunction(props.deleteAction)) {
      setProcessing(true);
      const payload = new FormData();

      selectedList?.map( a => { payload.append('id', a?.id); });

      props
        .deleteAction(payload, successMessage, errorMessage)
        .then((res) => {
          if (res && res.status) {
            setModalOpen(false);
            if (_.isFunction(props.onSuccess)) {
              props.onSuccess(id);
            }
          }
        })
        .catch(apiErrorHandler)
        .finally(() => setProcessing(false));
    }
  }

  return (
    <ModalButtonArea
      className="smallPopup"
      iconOnly={props.iconOnly}
      button={props.button}
      bigButton={props.bigButton}
      bigBtnClass={props?.bigBtnClass}
      hideButtonText={props.hideButtonText}
      miniButton={props.miniButton}
      footerButton={props.footerButton}
      icon={props.icon}
      variant={props.disabled ? 'outline-secondary' : 'outline-dark'}
      buttonIcon={buttonIcon}
      buttonTitle={_.startCase(actionWord)}
      disabled={props.disabled || false}
      title={props.title || deleteTitle}
      subtitle={props.subtitle || deleteDescription}
      size="md"
      setShowModal={setModalOpen}
      showModal={modalOpen}
      includeCancelButton={true}
      promptButton={
        <BigButton
          onClick={processAction}
          className={'lf-btn-3 keep-text'}
          disabled={processing}
          isLoading={processing}
          variant={processing ? 'outline-secondary' : 'outline-dark'}
          buttonTitle={deleteButtonPrompt}
        />
      }
      // iconSrc={iconSrc}
      buttonLabel={props.buttonLabel}
    />
  );
}
